@if (stats().total > 0) {
  <div style="min-width: 200px">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <span class="small text-muted">{{ 'screening.case.review.progress_label' | translate }}</span>
      <span class="small">{{ stats().completed }} / {{ stats().total }}</span>
    </div>
    <div class="progress">
      <div
        class="progress-bar"
        role="progressbar"
        [class.bg-success]="stats().percentage === 100"
        [class.bg-info]="stats().percentage < 100"
        [style.width.%]="stats().percentage"
        [attr.aria-valuenow]="stats().completed"
        aria-valuemin="0"
        [attr.aria-valuemax]="stats().total"></div>
    </div>
  </div>
}
